import api from "../index";

// Get all feedbacks
export const getAllFeedbacks = async () => {
  return await api.get(`/feedbacks`);
};

// Get all feedbacks paginated
export const getAllFeedbacksPaginated = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/feedbacks/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/feedbacks/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get a feedback by id
export const getFeedbackById = async (id: any) => {
  return await api.get(`/feedback/${id}`);
};

// Delete a feedback by id
export const deleteFeedbackById = async (id: any) => {
  return await api.delete(`/feedback/${id}`);
};
